export const GET_USER_PENDING = "GET_USER_PENDING";
export const GET_MORE_USER_PENDING = "GET_MORE_USER_PENDING";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_MORE_USER_SUCCESS = "GET_MORE_USER_SUCCESS";
export const RESET_USER = "RESET_USER";
